module.exports = __webpack_public_path__ + "static/banking-29b4368e9cb37e2e79228f29ef8f3ade.png";